var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-slider-bullet js-slider-bullet"},[_c('span',{staticClass:"main-slider-bullet__text js-slider-bullet__text"},[_vm._v(_vm._s(_vm.bulletIndex))]),_c('span',{staticClass:"main-slider-bullet__line js-slider-bullet__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }